import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Typography } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose1 from "../../Assets/yoga/pose1.jpg";
import pose2 from "../../Assets/yoga/pose2.jpg";

const { Sider, Content } = Layout;
const { Title, Paragraph } = Typography;

const DemoYoga = () => {
  const [selectedKey, setSelectedKey] = useState("home");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const handleLeftMenu = (e) => setSelectedKey(e.key);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fadeSlide = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
    exit: { opacity: 0, y: -20, transition: { duration: 0.4 } },
  };
  // 🧭 Central page content
  const pages = {
    home: (
      <>
        <Title level={2} style={{ textAlign: "center" }}>
          What is Yoga?
        </Title>
        <Paragraph
          style={{
            textAlign: "center",
            maxWidth: 700,
            margin: "10px auto",
            lineHeight: 1.7,
          }}
        >
          Yoga means "union" - the union of body, mind and soul. It is a
          5,000-year-old Indian tradition.
        </Paragraph>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        >
          <Card style={{ marginBottom: "20px" }}>
            <h2 style={{ color: "green" }}>The main types of yoga are:</h2>
            <ol style={{ lineHeight: 1.8 }}>
              <b>
                <li>Hatha Yoga</li>
              </b>
              <p>Yoga through physical exercises</p>
              <p>Asanas + Pranayama</p>
              <p>Suitable for beginners</p>
              <b>
                <li>Raja Yoga</li>
              </b>
              <p>Yoga of mind control</p>
              <p>Attaining samadhi through meditation</p>
              <b>
                <li>Karma Yoga</li>
              </b>
              <p>Yoga through service</p>
              <p>Action without attachment</p>
              <b>
                <li>Jnana Yoga</li>
              </b>
              <p>Yoga through knowledge</p>
              <p>"Who am I?" Research on</p>
              <b>
                <li>Bhakti Yoga</li>
              </b>
              <p>Yoga through devotion</p>
              <p>Complete surrender to God</p>
            </ol>
          </Card>
          <Card style={{ marginBottom: "20px" }}>
            <h2 style={{ color: "green" }}>
              The 8 limbs of yoga (Ashtanga Yoga):
            </h2>
            <ol style={{ lineHeight: 1.8 }}>
              <b>
                <li>Yama (5 precepts - external conduct)</li>
              </b>
              <p>Ahimsa - non-killing</p>
              <p>Truthfulness - non-lying</p>
              <p>Asteyam - non-stealing</p>
              <p>Brahmacharya - restraint of the senses</p>
              <p>Aparigrama - absence of desire</p>
              <b>
                <li>Niyama (5 precepts - internal conduct)</li>
              </b>
              <p>Saucham - cleanliness</p>
              <p>Happiness - mental contentment</p>
              <p>Tapas - hard training</p>
              <p>Svadhyayam - self-knowledge</p>
              <p>Eswara Pranidhanam - surrender to God</p>
              <b>
                <li>Asana</li>
              </b>
              <p>Positions</p>
              <p>Stability and comfort</p>
              <b>
                <li>Pranayama</li>
              </b>
              <p>Breath control</p>
              <p>Management of the life force</p>
              <b>
                <li>Pratyakara</li>
              </b>
              <p>Introspection of the senses</p>
              <b>
                <li>Dharana</li>
              </b>
              <p>Focusing the attention</p>
              <b>
                <li>Dhyana</li>
              </b>
              <p>Continuous flow of attention</p>
              <b>
                <li>Samadhi</li>
              </b>
              <p>The state of complete unity</p>
            </ol>
          </Card>
          <Card style={{ marginBottom: "20px" }}>
            <h2 style={{ color: "green" }}>Scientific Benefits of Yoga:</h2>
            <h3>For the Body:</h3>
            <ul>
              <li>Increased Flexibility</li>
              <li>Increased Muscle Strength</li>
              <li>Strengthened Skeletal System</li>
              <li>Improved Blood Flow</li>
              <li>Improved Immunity</li>
            </ul>
            <h3>For the Mind:</h3>
            <ul>
              <li>Reduced Stress</li>
              <li>Improved Focus</li>
              <li>Emotional Balance</li>
              <li>Improved Sleep</li>
              <li>Increased Mental Satisfaction</li>
            </ul>
            <h3>Daily Yoga:</h3>
            <ul>
              <p style={{ color: "red" }}>Morning (Early Morning)</p>
              <li>Shudhi - Neti, Kapalabhati</li>
              <li>Pranayama - 10 Minutes</li>
              <li>Surya Namaskar - 12 Rounds</li>
              <li>Asanas - 30-45 Minutes</li>
              <li>Meditation - 10-15 Minutes</li>
            </ul>
            <h3>Evening (Evening):</h3>
            <ul>
              <li>Hatha Yoga - Slow Asanas</li>
              <li>Savasana - 10-15 Minutes</li>
            </ul>
            <h3>Guarantee for Beginners of Yoga:</h3>
            <ul>
              <p style={{ color: "red" }}>Required Equipment</p>
              <li>Yoga Mat</li>
              <li>Comfortable Clothes</li>
              <li>Empty Stomach (2-3 hours before practice)</li>
            </ul>
            <h2 style={{ color: "red" }}>Important notes:</h2>
            <ul>
              <li>In the beginning, teacher guidance is important</li>
              <li>Do according to physical ability</li>
              <li>Do not be competitive</li>
              <li>Focus on breathing</li>
              <li>Savasana is important</li>
            </ul>
            <h2>Key philosophies of yoga:</h2>
            <ul>
              <li>Yoga is the cessation of mind waves</li>
              <li>Sthiram Sugam Asanam</li>
              <li>Asana is stable and comfortable</li>
              <li>Ahimsa Paramo Dharma</li>
              <li>Non-violence is the highest</li>
            </ul>
          </Card>
        </motion.div>
      </>
    ),
    left1: (
      <div style={{ lineHeight: "1.8", color: "#222", fontSize: "16px" }}>
        <h2 style={{ textAlign: "center", color: "#054d31" }}>Hatha Yoga</h2>

        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          What is Hatha Yoga?
        </h3>
        <p>
          <b>"Hatha Yoga"</b> is an important and fundamental branch of yoga. It
          is a way of balancing the body and mind. The word <b>Hatha</b> means:
          “<b>Ha</b>” means <i>sun</i>, “<b>Tha</b>” means <i>moon</i>. This
          refers to the sun and the moon, which means that the purpose of Hatha
          Yoga is to balance the negative and positive forces, male and female
          forces, or hot and cold forces within us.
        </p>
        <p>
          In simple terms, Hatha Yoga is a system of practice that mainly
          focuses on <b>physical postures (asanas)</b>,{" "}
          <b>breath control (pranayama)</b>, and <b>meditation</b> to calm the
          mind and lead to spiritual growth.
        </p>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
          Key Features of Hatha Yoga:
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <b>Asanas:</b> These are various yoga postures that help keep the
            body strong, flexible, and balanced. <i>Examples:</i> Padmasana,
            Sirsasana, Bhujangasana etc.
          </li>
          <li>
            <b>Pranayama:</b> This is the art of controlling the breath and
            directing the "prana" (life force) in our body. It helps to calm the
            mind and increase energy.
          </li>
          <li>
            <b>Mudras & Bandhas:</b>Controlling the flow of energy through
            specific positions of the hands and other parts of the body.
          </li>
          <li>
            <b>Dhyana:</b> Entering a state of calm meditation after the mind
            has been calmed through asana and pranayama.
          </li>
          <li>
            <b>Shatkriyas:</b> Six types of cleansing exercises that help to
            remove toxins from the body. Benefits of Hatha Yoga
          </li>
        </ul>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
          Hatha Yoga provides a variety of physical and mental benefits.
        </h3>
        <h4 style={{ color: "#157347", marginTop: "15px" }}>
          Health Benefits:
        </h4>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Increases the strength, flexibility and balance of the body.</li>
          <li>Strengthens muscles and bones.</li>
          <li>
            Improves blood circulation and increases oxygen supply to all parts
            of the body.
          </li>
          <li>Strengthens the immune system.</li>
          <li>Improves digestion and body metabolism.</li>
          <li>Helps in controlling body weight.</li>
          <li>Helps you get a good night's sleep.</li>
        </ul>

        <h4 style={{ color: "#157347", marginTop: "15px" }}>
          Mental health Benefits:
        </h4>
        <ul style={{ paddingLeft: "20px" }}>
          <li>Reduces stress, anxiety, and depression.</li>
          <li>Calms the mind and improves focus.</li>
          <li>Increases mental clarity.</li>
          <li>Develops self-awareness and spiritual peace.</li>
        </ul>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>Who can do it?</h3>
        <p>
          Hatha yoga is suitable for everyone. Anyone who is new to yoga should
          start with Hatha yoga. It is a very slow and controlled practice that
          teaches the basics of yoga.
        </p>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
          Some simple Hatha yoga poses to start with
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <b>Tadasana (Mountain Pose):</b> Balance check pose.
          </li>
          <li>
            <b>Vrikshasana (Tree Pose):</b> Improves balance and stability.
          </li>
          <li>
            <b>Padmasana (Lotus Pose):</b> A sitting pose suitable for
            meditation.
          </li>
          <li>
            <b>Bhujangasana (Cobra Pose):</b> A pose that strengthens the spine.
          </li>
          <li>
            <b>Uttanasana (Forward Bend):</b> A pose that stretches the body.
          </li>
        </ul>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>Important Note:</h3>

        <blockquote
          style={{
            marginTop: "20px",
            fontStyle: "italic",
            borderLeft: "4px solid #0c5c78",
            paddingLeft: "12px",
            color: "#333",
            background: "#f4f9f9",
          }}
        >
          It is very important to learn Hatha Yoga under the guidance of a
          qualified Yoga teacher. It should be done according to the body and
          should not cause pain. In short, Hatha Yoga is a wonderful science
          that everyone can follow in the modern era and make it a part of their
          lifestyle. It is a great art that integrates the three: body, mind and
          soul.
        </blockquote>
      </div>
    ),

    left2: (
      <div style={{ lineHeight: "1.8", color: "#222", fontSize: "16px" }}>
        <h2 style={{ textAlign: "center", color: "#4a148c" }}>Raja Yoga</h2>

        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          What is Raja Yoga?
        </h3>
        <p>
          The word <b>"Raja Yoga"</b> literally means <i>"Royal Yoga"</i> or{" "}
          <i>"King of Yogas"</i>. It is a path to spiritual elevation by
          controlling our mind.
        </p>
        <p>
          While <b>Hatha Yoga</b> begins with the body and reaches to the mind,{" "}
          <b>Raja Yoga</b> works directly on the mind. This system of yoga was
          formalized by the sage <b>Patanjali</b> in his book{" "}
          <i>“Yoga Sutras”</i>. Therefore, it is also called{" "}
          <b>“Ashtanga Yoga”</b> (eight-limbed yoga).
        </p>
        <p>
          In simple terms, <b>Raja Yoga</b> is the supreme path that teaches you
          to completely control your own mind. The Foundation of Raja Yoga:
          Ashtanga Yoga (Eight Limbs). Raja Yoga is a gradual process. The eight
          steps (elements) are as follows
        </p>

        <ol style={{ paddingLeft: "20px" }}>
          <li>
            <b>Yama (Social Morality):</b> These are the morals to be observed
            while living in the outside world. There are five rules in this:
            <ul>
              <li>Ahimsa — non-violence to any living being.</li>
              <li>Satya — speaking the truth.</li>
              <li>Asteya — Non-stealing </li>
              <li>Brahmacharya — Control of the senses.</li>
              <li>
                Aparigraha — absence of desire, not collecting unnecessary
                things.
              </li>
            </ul>
          </li>

          <li>
            <b>Niyama (Personal Morality):</b> The rules to be observed by an
            individual for his/her own development. There are five in this:
            <ul>
              <li>Saucham — physical and mental purity.</li>
              <li>Santosha — being contented.</li>
              <li>Tapas — determination to endure difficult situations.</li>
              <li>
                Svadhyayam — knowledge about oneself, reading spiritual books.
              </li>
              <li>Ishvara Pranidhanam — surrender to God.</li>
            </ul>
          </li>

          <li>
            <b>Asana (seat/Posture):</b> Here "asana" refers to a comfortable,
            stable position for meditation. If the body is stable, the mind will
            also be stable.
          </li>

          <li>
            <b>Pranayama (Breath Control):</b> The art of controlling the prana
            (life force). Controlling the breath and controlling the mind.
          </li>

          <li>
            <b>Pratyahara (Withdrawal of the Senses):</b>Our five senses (eyes,
            ears, nose, tongue, skin) are constantly directed towards the
            outside world. The aim is to turn the outward flow of these five
            senses inwards and examine the mind.
          </li>

          <li>
            <b>Dharana (Concentration):</b> After Pratyahara, the mind is
            focused on a single idea or object. (e.g., the breath, a mantra, a
            bright spot). This is a practice of focusing attention.
          </li>

          <li>
            <b>Dhyana (Meditation):</b> After the mind has settled on one point
            in meditation, it is absorbed in the uninterrupted flow of that
            single thought. The duality of thought and thinker disappears.
          </li>

          <li>
            <b>
              Samadhi (Samadhi - Consciousness of the Real Thing / Connection):
            </b>{" "}
            This is the ultimate goal of Raja Yoga. When meditation is fully
            developed, one forgets oneself and becomes completely united with
            the thought. In this state, there is bliss, peace and union with the
            Supreme.
          </li>
        </ol>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
          Benefits of Raja Yoga
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <b>Mind Control:</b> It teaches us to keep the mind under control.
          </li>
          <li>
            <b>Inner Peace:</b> External disturbances do not affect the inside.
          </li>
          <li>
            <b>Moral Life:</b> Yama-Niyamas help to organize life.
          </li>
          <li>
            <b>Self-Awareness:</b> Through meditation, we can know more about
            ourselves.
          </li>
          <li>
            <b>Mental Clarity:</b> We can think clearly about any problem.
          </li>
        </ul>

        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
          Raja Yoga vs. Hatha Yoga
        </h3>
        <div
          style={{
            overflowX: "auto",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "10px",
            marginBottom: "20px",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
              fontSize: "15px",
            }}
          >
            <thead>
              <tr style={{ background: "#f4f9f9" }}>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Aspect
                </th>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Hatha Yoga
                </th>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Raja Yoga
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Attention
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Starting with the body and reaching the mind
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Direct attention to the mind
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Main practice
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Asanas and Pranayama
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Eight steps to control the mind
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Goal
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Body-mind balance
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Samadhi/Moksha through the mind
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Parable
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Paving the road to the house
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Controlling the car on the road
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <blockquote
          style={{
            marginTop: "20px",
            fontStyle: "italic",
            borderLeft: "4px solid #4a148c",
            paddingLeft: "12px",
            color: "#333",
            background: "#f4f9ff",
          }}
        >
          “In short, Raja Yoga is a psychological and spiritual science. It is a
          possible and practical path that everyone can follow to discover their
          true self, using their mind as a laboratory, through meditation and a
          moral life.”
        </blockquote>
      </div>
    ),

    left3: (
      <>
        <div style={{ lineHeight: "1.8", color: "#222", fontSize: "16px" }}>
          <h2 style={{ textAlign: "center", color: "#f20837ff" }}>
            Karma Yoga
          </h2>
          <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
            What is Karma Yoga?
          </h3>
          <p>
            Karma Yoga is also known as <b>"karma yoga"</b> or{" "}
            <b>"yoga of action"</b>. It is the path of spiritual progress
            through human actions.
          </p>
          <p>
            The core idea of Karma Yoga can be summed up in one sentence:{" "}
            <b>"Karma Yoga</b> is the performance of duty without attachment and
            without fear."
          </p>
          <p>
            This idea is very clearly stated in the Bhagavad Gita. The Gita is a
            great lesson in which Krishna explains the importance of Karma Yoga
            to Arjuna.
          </p>
          <h3>The basic philosophy of Karma Yoga</h3>
          <p>
            Action cannot be abandoned: As long as the human body exists, we
            will have to engage in some action. It cannot be avoided.
          </p>
          <p>
            The important thing is not the action, but the attitude of doing:
            Karma Yoga focuses on how we do it rather than what we do.
          </p>
          <h3>Three important aspects of Karma Yoga</h3>
          <p>To follow Karma Yoga correctly, three things must be observed:</p>
          <ol style={{ paddingLeft: "20px" }}>
            <li>Detachment from Results:</li>
            <ul>
              <li>This is the most important concept of Karma Yoga.</li>
              <li>
                When we do an action, we should not have any attachment to the
                result of that action.
              </li>
              <li>
                We should not expect success, failure, profit, loss, praise, or
                scolding.
              </li>
              <li>"Do your duty, do not expect results" is the mantra.</li>
            </ul>
            <li>Selfless Duty:</li>
            <ul>
              <li>
                Acting without self, for the benefit of others, for the benefit
                of the world.
              </li>
              <li>
                Acting with the thought "This is my duty" and without the ego of
                "I".
              </li>
              <li>An attitude of forgetting oneself and serving.</li>
            </ul>
            <li>Offering to the Divine:</li>
            <ul>
              <li>
                The attitude of dedicating every action we do and its results to
                God.
              </li>
              <li>
                The thought, "I am not the doer, I am only an instrument."
              </li>
              <li>The thought, "All my actions are your service."</li>
            </ul>
          </ol>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
            Benefits of Karma Yoga
          </h3>
          <p>
            Freedom from karmic bondage: Every selfish action entangles us in a
            karmic bond (vriya). Serene action breaks that bond.
          </p>
          <p>
            <b>Peace of mind:</b> When we act without expecting reward, worry,
            anger, and disappointment leave us.
          </p>
          <p>
            <p>Destruction of ego:</p> The thought of "I" and "mine" diminishes.
          </p>
          <p>
            <b>Spiritual growth:</b> Ultimately, this detached action leads us
            to self-realization and liberation.
          </p>
          <p>How to practice Karma Yoga? (In practical life)</p>
          <p>Karma Yoga is not just about sitting; it is a way of life</p>
          <p>
            <b>At home:</b> When you serve your family members, do it without
            expecting praise.
          </p>
          <p>
            <b>In the office:</b> Do your job full-time and honestly. Don't be
            attached to promotions or bonuses.
          </p>
          <p>
            <b>In society:</b> Help others voluntarily. Don't expect fame or
            fame.
          </p>
          <p>
            <b>In small actions:</b> Do even daily duties like housework,
            cooking, and washing clothes as if they were a sacrifice.
          </p>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
            Karma Yoga vs Other Yogas:
          </h3>
          <div
            style={{
              overflowX: "auto",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginTop: "10px",
              marginBottom: "20px",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              <thead>
                <tr style={{ background: "#f4f9f9" }}>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Aspect
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Karma Yoga
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Hatha Yoga
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Raja Yoga
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Path
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Through Action
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Mind Control
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Through Knowledge
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    State of Mind
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Action Given Up
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Mental Suppression Through Meditation
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    The Feeling of "I Am Not Me" (Ego Destruction)
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    For Whom?
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    All Those Who Are Involved in Action
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Those Interested in Meditation
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Those Interested in Philosophical Knowledge
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>Conclusion:</h3>
          <blockquote
            style={{
              marginTop: "20px",
              fontStyle: "italic",
              borderLeft: "4px solid #4a148c",
              paddingLeft: "12px",
              color: "#333",
              background: "#f4f9ff",
            }}
          >
            “Karma Yoga is a universal medicine. It has the power to transform
            every action of our daily life into a sacred spiritual practice.
            Just as one who plants a tree, without worrying about its shade,
            should continue to do our duty. That is the path to true
            liberation.”
          </blockquote>
        </div>
      </>
    ),
    left4: (
      <>
        <div style={{ lineHeight: "1.8", color: "#222", fontSize: "16px" }}>
          <h2 style={{ textAlign: "center", color: "#f26608ff" }}>
            Jnana Yoga
          </h2>
          <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
            What is Jnana Yoga?
          </h3>
          <p>
            Jnana Yoga is also known as the<b> "yoga of knowledge" </b>or the
            "yoga of consciousness". It is the direct path to the realization of
            spiritual truth through insight and philosophical wisdom.
          </p>
          <p>
            In simple terms: "Who am I?" "What is the true nature of this
            world?" "What is the Supreme?" Jnana Yoga is the path of asking,
            investigating, and realizing the truth through direct experience.
          </p>
          <p>
            It is considered the most difficult of the four main yogas because
            it requires a sharp mind, intense study, and the guidance of a guru.
          </p>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
            Basic Philosophy of Jnana Yoga
          </h3>
          <p>
            The core concept of Jnana Yoga is "Brahman Satyam, Jagat Mithya"
            (The Supreme is the only truth, this world is illusion). This means:
          </p>
          <p>
            <b>Brahman:</b> The only true, eternal, unchanging spiritual basis
            of this universe.
          </p>
          <p>
            <b>Atman:</b> The eternal individual soul within each living being.
          </p>
          <p>
            <b>Goal:</b> The goal is to directly realize that Atman and Brahman
            are one (Advaita). The state of experiencing that "I" and "God" are
            not separate.
          </p>
          <p>Four main stages of Jnana Yoga (Satana Chatushtayam)</p>
          <p>
            The Jnana Yogi must progress in a specific order. That is, four main
            qualifications:
          </p>
          <ol style={{ paddingLeft: "20px" }}>
            <li>
              <b>Viveka (Discrimination):</b>
            </li>
            <p>
              The ability to discriminate between the eternal (permanent) and
              the impermanent (temporary).
            </p>
            <p>
              Gaining clarity between the real (Brahman) and the unreal
              (universe).
            </p>
            <p>Realizing that the body, mind, and senses are not the "I"</p>
            <li>
              <b>Vairagya (Detached):</b>
            </li>
            <p>
              Giving up of desire and attachment to impermanent worldly objects
              and pleasures.
            </p>
            <p>
              After knowing through wisdom that "this is not true", the desire
              for it will automatically decrease.
            </p>
            <li>
              <b>Shat-Sampatti (Six Wealth):</b>
            </li>
            <p>The six mental qualities necessary for attaining wisdom:</p>
            <p>
              <b>Sama:</b> Peace of mind.
            </p>
            <p>
              <b>Dama:</b> Control of the senses.
            </p>
            <p>
              <b>Uparati:</b> Withdrawal of the mind from the senses.
            </p>
            <p>
              <b>Titiksha:</b> Tolerance of heat, water, pleasure and pain.
            </p>
            <p>
              <b>Shraddha:</b> Unwavering faith in the guidance of the Guru and
              the Vedas
            </p>
            <p>
              <b>Samadhana:</b> Single concentration of the mind.
            </p>
            <li>
              <b>Mumukshutva (Intense desire for liberation):</b>
            </li>
            <p>
              Above all, an intense, burning desire for liberation or
              self-realization.
            </p>
            <p>
              Just as a man in a state of thirst asks for water, so one should
              ask for liberation.
            </p>
          </ol>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
            Main Methods of Jnana Yoga
          </h3>
          <p>
            After attaining these qualifications, a Jnana Yogi follows three
            main steps:
          </p>
          <ol style={{ paddingLeft: "20px" }}>
            <li>
              <b>Inquiry (Shravana):</b>
            </li>
            <p>
              Hearing true knowledge (Upanishads, Vedanta philosophies) from a
              qualified guru.
            </p>
            <li>
              <b> Reflection (Manana):</b>
            </li>
            <p>
              Repeatedly reflecting on what has been heard in one's mind,
              resolving all doubts and fully understanding it.
            </p>
            <li>
              <b>Meditation (Nididhyasana):</b>
            </li>
            <p>
              Deeply immersing the mind in that knowledge and transforming it
              into a direct experience. "I am Brahman" (Aham Brahmasmi) becomes
              not a concept but a living experience.
            </p>
          </ol>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
            Benefits of Jnana Yoga:
          </h3>
          <p>
            <b>Real knowledge:</b> Direct knowledge of the true self (Atma).
          </p>
          <p>
            <b>Complete destruction of ego:</b> Complete disappearance of the
            idea of "I" and "mine".
          </p>
          <p>
            <b>Eternal freedom:</b> Complete freedom from all forms of karmic
            bondage.
          </p>
          <p>
            <b>Bliss:</b> The supreme bliss of seeing the one Supreme Being in
            everything.
          </p>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>
            Jnana Yoga vs Other Yogas:
          </h3>
          <div
            style={{
              overflowX: "auto",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginTop: "10px",
              marginBottom: "20px",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              <thead>
                <tr style={{ background: "#f4f9f9" }}>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Aspect
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Jnana Yoga
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Karma Yoga
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Bhakti Yoga
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Raja Yoga
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Path
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Knowledge & Self-Study
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Selfless Action
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Love & Devotion
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Mind Control
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Instrument
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Sharp Mind
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Actions & Service
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Heart & Feelings
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Mind & Breath
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    Mindset
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    "I am Him" (Aham Brahmasmi)
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    "Actions are for God"
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    You are my Master"
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                    I control the mind"
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>Conclusion:</h3>
          <blockquote
            style={{
              marginTop: "20px",
              fontStyle: "italic",
              borderLeft: "4px solid #4a148c",
              paddingLeft: "12px",
              color: "#333",
              background: "#f4f9ff",
            }}
          >
            “Jnana Yoga is a science of the mind. It is an intense spiritual
            journey that leads a person to complete self-realization through his
            own thought and experience. It is not an easy path, but it is
            considered the fastest and most direct path that connects man
            directly to the truth. This yoga proves that "true wisdom is to know
            oneself".”
          </blockquote>
        </div>
      </>
    ),
    left5: (
      <div style={{ lineHeight: "1.8", color: "#222", fontSize: "16px" }}>
        <h2 style={{ textAlign: "center", color: "#ac06eeff" }}>Bhakti Yoga</h2>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          What is Bhakti Yoga?
        </h3>
        <p>
          Bhakti Yoga is the <b>"yoga of love and devotion".</b> It is the path
          of spiritual progress through complete love and surrender to God.
        </p>
        <p>
          <b>In simple terms:</b> Bhakti Yoga is accepting God as one's master
          and placing complete love and trust in Him. It is considered an easy
          path for everyone to follow as it uses the natural feelings of the
          mind to reach God.
        </p>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          Basic Philosophy of Bhakti Yoga
        </h3>
        <p>
          The core concept of Bhakti Yoga is{" "}
          <b>"to love God above all else".</b> Here, the relationship between
          the devotee and the Supreme (God) is like "love".
        </p>
        <p>
          <b>Devotee:</b> One who loves God (the beloved).
        </p>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          Bhagavan: God (the beloved).
        </h3>
        <p>
          <b>Goal</b> To restore the connection between the devotee and the Lord
          and to unite with Him.
        </p>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          Nine Paths of Bhakti Yoga (Nava Vidha Bhakti)
        </h3>
        <p>
          When Lord Rama was asked by his devotee Hanuman, "What should devotion
          be like?", Lord Rama explained the nine paths of devotion (Nava Vidha
          Bhakti). These are the basic principles of Bhakti Yoga:
        </p>
        <p>
          <b>Sarvanam (Hearing):</b> Listening to the praises, hymns, and
          stories of God.
        </p>
        <p>
          <b>Kirtanam (Singing):</b> Singing the praises of God.
        </p>
        <p>
          <b>Smaranam (Remembering):</b>Always chanting the name of God,
          thinking of Him.
        </p>
        <p>
          <b>Padasevanam (Worshiping the feet):</b> Serving in the temples of
          God, worshipping Him within.
        </p>
        <p>
          <b>Archanam (Worship):</b> Performing acts of worship such as puja,
          aarti.
        </p>
        <p>
          <b>Vandanam (worship):</b> To bow down to God.
        </p>
        <p>
          <b>Dasyam (servant):</b> To serve with the idea of being a servant of
          God.
        </p>
        <p>
          <b>Sahyam (friendship):</b> To consider God as one's friend.
        </p>
        <p>
          Atma Nivedanam (surrender): To surrender oneself completely to God.
          ("My everything is yours").
        </p>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          Key features of Bhakti Yoga
        </h3>
        <ol style={{ paddingLeft: "20px" }}>
          <li>
            <b>Personal God (Ishta Deity):</b>
          </li>
          <p>
            Bhakti Yoga focuses on a personal God (Ishta Deity). Be it Krishna,
            Rama, Shiva, Amma, Jesus.
          </p>
          <li>
            <b>Bhakti does not require achievements:</b>
          </li>
          <p>
            Jnana Yoga requires a sharp mind. Raja Yoga requires control. But
            for Bhakti Yoga, only love for God is sufficient.
          </p>
          <li>
            <b>Leaving the fruit to God:</b>
          </li>
          <p>
            The devotee surrenders all his worries and the fruits of his actions
            to God. "The belief that what you do will be good."
          </p>
          <li>
            <b> The simple way:</b>
          </li>
          <p>
            This is a very simple and natural path. There is no obstacle to
            saying the name of God.
          </p>
        </ol>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          Benefits of Bhakti Yoga:
        </h3>
        <p>
          <b>Peace of mind:</b> By surrendering to God, worries and fears are
          reduced.
        </p>
        <p>
          <b>Purity of heart:</b> Good qualities like love, compassion, patience
          grow.
        </p>
        <p>
          <b>Destruction of ego:</b> As the thought of "I am the one who does
          it" decreases, the belief that "He will do it" grows.
        </p>
        <p>
          <b>Destruction of ego:</b> As the thought of "I am the one who does
          it" decreases, the belief that "He will do it" grows.
        </p>
        <p>
          <b>Spiritual bliss: </b>The joy that is derived from chanting,
          singing, and acting the name of God.
        </p>
        <p>
          <b>Essence of all yogas:</b> The belief that ultimately, all yoga
          paths culminate in devotion.
        </p>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          Bhakti Yoga vs Other Yogas:
        </h3>
        <div
          style={{
            overflowX: "auto",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginTop: "10px",
            marginBottom: "20px",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
              fontSize: "15px",
            }}
          >
            <thead>
              <tr style={{ background: "#f4f9f9" }}>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Aspect
                </th>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Bhakti Yoga
                </th>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Jnana Yoga
                </th>
                <th style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Karma Yoga
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Path
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Heart & Love
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Mind & Knowledge
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Action & Service
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Relationship
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  "I am the slave, you are the master"
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  "I am him"
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  "Actions are for you"
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Mindset
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Devotion & Surrender
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Study & Meditation
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Detachment & Duty
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>Conclusion:</h3>
        <blockquote
          style={{
            marginTop: "20px",
            fontStyle: "italic",
            borderLeft: "4px solid #4a148c",
            paddingLeft: "12px",
            color: "#333",
            background: "#f4f9ff",
          }}
        >
          “Bhakti Yoga is the path of the heart. It provides a simple and sweet
          way to reach God. Just as a small child has complete trust and love
          for its mother, so too does a devotee have complete trust in his
          beloved deity. The phrase "Anbe Shiva" perfectly expresses the essence
          of this yoga.”
        </blockquote>
      </div>
    ),
    left6: (
      <div style={{ lineHeight: "1.8", color: "#222", fontSize: "16px" }}>
        <h2 style={{ textAlign: "center", color: "#0606eeff" }}>
          Ashtanga Yoga
        </h2>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          What is Ashtanga Yoga?
        </h3>
        <p>
          The word Ashtanga Yoga means{" "}
          <b>"yoga with eight (ashtanga) limbs".</b> This system is explained in
          detail by the sage Patanjali in his Yoga Sutras.
        </p>
        <p>
          It is the basis of Raja Yoga, and it provides a systematic and gradual
          path that leads a person to a higher spiritual state. These eight
          limbs are like the branches of a tree; all emanate from the same root
          and lead to the same goal.
        </p>
        <h3 style={{ color: "#0c5c78", marginTop: "20px" }}>
          The 8 limbs (steps) of Yoga
        </h3>
        <p>
          These eight steps are arranged systematically, one after the other.
          Mastering one step helps one move on to the next.
        </p>
        <ol style={{ paddingLeft: "20px" }}>
          <li style={{ color: "green" }}>
            <b>Yama (social morality):</b>
          </li>
          <p>
            These are the five morals that must be observed while living in the
            outside world
          </p>
          <p>
            <b>Ahimsa: Non-violence:</b> Non-harm to any living being. It should
            be applied to all aspects of body, speech and thought.
          </p>
          <p>
            <b>Truth (Satya):</b> Always speaking the truth. But the truth
            should not harm another.
          </p>
          <p>
            <b>Asteya:</b> Non-stealing. Not taking advantage of other people's
            things, thoughts and opportunities.
          </p>
          <p>
            <b>Brahmacharya:</b> Control of the senses. Not wasting energy and
            saving it for spiritual growth.
          </p>
          <p>
            <b>Aparigraha:</b> Absence of desire, not collecting unnecessary
            things.
          </p>
          <li style={{ color: "green" }}>
            <b>Niyama (Personal Disciplines):</b>
          </li>
          <p>
            These are the five rules that an individual must follow for his/her
            development.
          </p>
          <p>
            <b>Saucha:</b> Cleanliness. Keeping both the body (external
            cleanliness) and the mind (internal cleanliness).
          </p>
          <p>
            <b>Santosha:</b> Contentment. Living contentedly in the present.
          </p>
          <p>
            <b>Tapas:</b> Determination. The inner strength to endure difficult
            situations for spiritual growth.
          </p>
          <p>
            <b>Svadhyaya:</b> Self-study. Knowledge of oneself, reading
            spiritual books.
          </p>
          <p>
            <b>Ishvara Pranidhana:</b> Surrender to God. Surrendering the
            results of all actions to God.
          </p>
          <li style={{ color: "green" }}>
            <b>Asana (seat/posture):</b>
          </li>
          <p>
            Here "asana" refers to a comfortable, stable physical position for
            meditation.
          </p>
          <p>
            According to Patanjali, asana should be "sthira and sugam" (stable
            and comfortable).
          </p>
          <p>If the body is stable, the mind will also be stable.</p>
          <li style={{ color: "green" }}>
            <b>Pranayama (breath control):</b>
          </li>
          <p>
            The practice of ayama (stretching, controlling) of the prana (life
            force).{" "}
          </p>
          <p>
            Controlling the breath and thereby suppressing the waves in the mind
          </p>
          <li style={{ color: "green" }}>
            <b>Pratyahara (withdrawal of the senses):</b>
          </li>
          <p>
            Our five senses (eyes, ears, nose, tongue, skin) are constantly
            directed towards the outside world.
          </p>
          <p>
            The purpose of this is to turn the outward flow of these five senses
            inward and examine the mind.
          </p>
          <p>The analogy is like a tortoise drawing its limbs inward.</p>
          <li style={{ color: "green" }}>
            <b>Dharana (concentration of attention):</b>
          </li>
          <p>
            After Pratyahara, the mind is focused on a single idea or object.
          </p>
          <p>
            This is the practice of focusing attention. (e.g., breathing, a
            mantra, a bright spot).
          </p>
          <li style={{ color: "green" }}>
            <b>Dhyana (meditation):</b>
          </li>
          <p>
            After the mind is fixed on a single point in Dharana, meditation is
            engaging in a continuous, uninterrupted flow of that single idea.
          </p>
          <p>
            Here, the duality of idea and perceiver is reduced, and a continuous
            flow is created.
          </p>
          <li style={{ color: "green" }}>
            <b>
              Samadhi (Samadhi - Consciousness of the Real Self / Unity with the
              Supreme Being)
            </b>
          </li>
          <p>This is the ultimate goal of Ashtanga Yoga.</p>
          <p>
            When meditation is fully deepened, one completely forgets oneself
            and becomes completely united with the concept.
          </p>
          <p>
            In this state, the perceiver, the concept and the object of
            perception become one.
          </p>
          <p>
            In this, there is bliss, peace and complete unity with the Supreme
            Being.
          </p>
        </ol>
        <h3 style={{ color: "#0c5c78", marginTop: "25px" }}>Importance:</h3>
        <blockquote
          style={{
            marginTop: "20px",
            fontStyle: "italic",
            borderLeft: "4px solid #4a148c",
            paddingLeft: "12px",
            color: "#333",
            background: "#f4f9ff",
          }}
        >
          “These eight steps are like the steps of a staircase. First, one
          should build discipline (yama-niyama) in social and personal life.
          Only then can the body (asana) and breathing (pranayama) come under
          control. Then, by controlling the mind (pratyakara, dharana, dhyana),
          one can reach the ultimate goal of samadhi.”
        </blockquote>
      </div>
    ),
  };

  const selectedContent = pages[selectedKey];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "stretch",
        minHeight: "100vh",
        height: "100%",
        padding: "30px 10px",
        background: "#f0f2f5",
      }}
    >
      <Layout
        style={{
          width: isMobile ? "100%" : "90%",
          maxWidth: "1340px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          overflow: "hidden",
          height: "auto",
        }}
      >
        {/* 🌿 LEFT SIDEBAR */}
        <motion.div
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            width: isMobile ? "100%" : "200px",
            height: isMobile ? "auto" : "100%",
          }}
        >
          <Sider
            width={isMobile ? "100%" : 230}
            style={{
              position: isMobile ? "relative" : "sticky",
              top: isMobile ? "0px" : "64px", // FIXED
              marginTop: isMobile ? "60px" : "0px",
              height: isMobile ? "auto" : "calc(100vh - 64px)",
              minHeight: isMobile ? "250px" : "unset",

              backgroundImage: `url(${pose1})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              overflow: "hidden",
              borderRight: isMobile
                ? "none"
                : "1px solid rgba(255,255,255,0.2)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            />

            {/* 🌿 Sidebar Content */}
            <div
              style={{
                position: "relative",
                zIndex: 2,
                padding: "16px",
                fontWeight: "bold",
                textAlign: "center",
                color: "#fff",
                fontSize: "1rem",
                letterSpacing: "0.5px",
                textShadow: "0 1px 3px rgba(0,0,0,0.8)",
              }}
            >
              {" "}
              Explore the types
            </div>

            <Menu
              theme="dark"
              mode="inline"
              style={{
                background: "transparent",
                color: "#fff",
                fontSize: "1.1rem",
                position: "relative",
                zIndex: 2,
                fontWeight: 500,
                textAlign: "center",
              }}
              onClick={handleLeftMenu}
              selectedKeys={[selectedKey]}
              items={[
                { key: "left1", label: "Hatha Yoga" },
                { key: "left2", label: "Raja Yoga" },
                { key: "left3", label: "Karma Yoga" },
                { key: "left4", label: "Jnana Yoga" },
                { key: "left5", label: "Bhakti Yoga" },
                { key: "left6", label: "Ashtanga Yoga" },
                { key: "home", label: "Back to Mainpage" },
              ]}
            />
          </Sider>
        </motion.div>

        {/*  MAIN CONTENT */}
        <Content
          style={{
            flex: 1,
            padding: isMobile ? "10px" : "30px 40px",
            width: "100%",

            background: "#fff",
            textAlign: "left",
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={selectedKey}
              variants={fadeSlide}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <Card
                style={{
                  borderRadius: "12px",
                  background: "#ffffff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                  padding: "24px",
                }}
              >
                {selectedContent}
              </Card>
            </motion.div>
          </AnimatePresence>
        </Content>
      </Layout>
    </motion.div>
  );
};

export default DemoYoga;
